/**
 * statusコマンドハンドラ
 *
 * プロジェクトの現在の状態を取得してコンソールに出力
 *
 * 使用例:
 * x:status
 */

import type { CommandHandler, CommandResult, ParsedCommand, CommandContext } from '../types';
import logger from '../../utils/logger';

export const statusHandler: CommandHandler = {
  name: 'status',
  description: 'Get project status summary',
  category: 'utility',
  parameters: [],
  aliases: [],
  examples: ['x:status'],

  execute: async (_args: ParsedCommand, context: CommandContext): Promise<CommandResult> => {
    // データセットを集計（ソースとDerivedを分ける）
    const allDatasets = Object.values(context.datasets);
    const sourceDatasets = allDatasets.filter(d => d.type === 'primary');
    const derivedDatasets = allDatasets.filter(d => d.type === 'derived');

    // 各種リソースの数を取得
    const tabs = context.getTabs();
    const models = context.getModels();
    const reports = context.getReports();

    const status = {
      datasets: sourceDatasets.length,
      derivedDatasets: derivedDatasets.length,
      tabs: tabs.length,
      models: models.length,
      reports: reports.length,
      activeDatasetId: context.getActiveDatasetId() ?? null,
      activeContainerId: context.getActiveContainerId()
    };

    // コンソールにJSON出力（AIエージェント向け）
    logger.info('[AgentCommand] Status', status);

    return {
      success: true,
      message: 'Status retrieved',
      data: status
    };
  }
};
